// extracted by mini-css-extract-plugin
export var errorsContainer = "_tq-1";
export var link = "_tq-0";